import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Component, ComponentRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-spinner-overlay',
  template: `
    <div class="spinner-wrapper">
      <div class="multi-spinner-container">
        <div class="multi-spinner">
            <div class="multi-spinner-accent">
                <div class="multi-spinner">
                  <div class="multi-spinner-accent">
                        <div class="multi-spinner">
                            <div class="multi-spinner-accent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [ './spinner.scss' ]
})
export class LoadingComponent {}

@Injectable({
  providedIn: 'root'
})
export class LoadingOverlayService {
  private overlayRef: OverlayRef | null = null;

  loadingMap: Map<string, boolean> = new Map<string, boolean>();

  constructor(private overlay: Overlay) {}

  show(message = '') {
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create();
    }
    if (this.loadingMap.size === 0) {
      const spinnerOverlayPortal = new ComponentPortal(LoadingComponent);
      this.overlayRef.attach(spinnerOverlayPortal);
    }
    this.loadingMap.set(message, true);
  }
  hide(message = '') {
    if (this.loadingMap.has(message)) {
      this.loadingMap.delete(message);
    }
    if (!!this.overlayRef && this.loadingMap.size === 0) {
      this.overlayRef.detach();
    }
  }
}